<template>
	<div class="row">
		<div class="col-md-3">
            <div class="card">
                <div class="card-header px-0 text-center">
                    <h5 class="header-title">TOTAL POSTS</h5>
                </div>
                <div class="card-body">
                    <div class="d-flex align-items-center justify-content-center">
                        <h2 class="number-l mb-0 mr-3">{{ stats.totalPosts }}</h2>
                        <i class="far fa-images brand-primary-gradient" style="font-size: 24px;"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-header px-0 text-center">
                    <h5 class="header-title">TOTAL LIKES
                    </h5>
                </div>
                <div class="card-body">
                    <div class="d-flex align-items-center justify-content-center">
                        <h2 class="number-l mb-0 mr-3">{{ abbrNum(stats.totalLikes, 2) }}</h2>
                        <i class="far fa-heart gradient-danger" style="font-size: 24px;"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-header px-0 text-center">
                    <h5 class="header-title">TOTAL CREATORS</h5>
                </div>
                <div class="card-body">
                    <div class="d-flex align-items-center justify-content-center">
                        <h2 class="number-l mb-0 mr-3">{{ stats.totalCreators }}</h2>
                        <i class="fa fa-user-friends brand-primary-gradient" style="font-size: 24px;"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card">
                <div class="card-header px-0 text-center">
                    <h5 class="header-title">TOTAL COMMENTS</h5>
                </div>
                <div class="card-body">
                    <div class="d-flex align-items-center justify-content-center">
                        <h2 class="number-l mb-0 mr-3">{{ abbrNum(stats.totalComments, 2) }}</h2>
                        <i class="far fa-comment brand-primary-gradient" style="font-size: 24px;"></i>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	props: ['stats']
}
</script>
